import type { DocMigration } from "../docMigration";

function cleanNote(note: any) {
  if (Object.keys(note).includes("textBoxWidth")) {
    delete note.textBoxWidth;
  }
  if (Object.keys(note).includes("textBoxHeight")) {
    delete note.textBoxHeight;
  }
}

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_442: DocMigration = {
  maxSchemaVersion: "0.0.442",
  description: "For all notes, remove existing text box sizes",
  apply(json: any) {
    for (const annotationKey in json.annotation) {
      const anno = json.annotation[annotationKey];
      cleanNote(anno);
    }

    for (const settingsKey in json.settings) {
      const settings = json.settings[settingsKey];
      if (settings.type === "ANNOTATION_CATALOG_SETTINGS") {
        for (const annotationTemplateKey in settings.annotationTemplates) {
          const annotationTemplate = settings.annotationTemplates[annotationTemplateKey];
          for (const componentKey in annotationTemplate.components) {
            const component = annotationTemplate.components[componentKey];
            cleanNote(component);
          }
        }
      }
    }

    return json;
  },
};

export default migration_0_0_442;
